import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, RecaptchaVerifier, signInWithPhoneNumber, signInWithPopup, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCxeCzZAQfZ5hsFQtOWH6RsaesS9wUDQS4",
  authDomain: "yessuhchill.firebaseapp.com",
  projectId: "yessuhchill",
  storageBucket: "yessuhchill.firebasestorage.app",
  messagingSenderId: "611185822379",
  appId: "1:611185822379:web:67534c9b5716d296ec85ee"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export { RecaptchaVerifier, signInWithPhoneNumber, signInWithPopup, signOut };
